module.exports = __webpack_public_path__ + "static/media/filter_icon.e926fcdc.svg";